<template>
<div class="w-full flex flex-col lg:flex-row">
    <div class="w-full lg:hidden containt-tabs-menu">
      <b-tabs ref="refTabsMenu"
        type="is-toggle-rounded"
        v-model="tabSelectedMenu"
        expanded
        class="sticky top-0 mb-3"
        @input="_HandleChangeTab">

        <b-tab-item label="Comentarios"
          value="tab_menu_comments"
          icon="comment-alt"
          icon-pack="fas" class="hidden"></b-tab-item>

        <b-tab-item
          label="Dashboard"
          value="tab_menu_dashboard"
          icon="chart-line"
          icon-pack="fas"></b-tab-item>

      </b-tabs>
    </div>

    <div class="w-full flex flex-row">
      <!-- Columna izquierda -->
      <div class="w-full lg:w-1/2 lg:mr-2" v-show="showPanel == 'left' || showPanel == 'both'">
        <div
        v-if="project.issue_template? project.can_admin || project.can_participate || project.can_view || project.can_issue_admin || project.can_issue_resolutor || project.can_collaborate
        : project.can_admin || project.can_participate || project.can_view"
        class="w-full column-scroll">
          <!-- Actividad -->
          <project-notifications ref="project_notifications"/>
        </div>
        <div v-else class="w-full column-scroll">
          <div class="panel">
            <span>{{ $t('empty_project_notifications') }}</span>
          </div>
        </div>

      </div>

      <!-- Columna derecha -->
      <div class="w-full lg:w-1/2 lg:ml-2" v-show="showPanel == 'right' || showPanel == 'both'">
        <div class="w-full column-scroll">

          <div v-if="showBtnDashboard"
            class="panel flex flex-wrap justify-center space-x-2 space-y-2">
              <button v-for="(btn, i) in GetBtnDashboard()" :key="'btn_dash' + i"
                class="button is-primary btn-blue mt-2 ml-2 is-size-7"
                @click="$router.push({ name: 'project.dashboard.' + btn.suffix_route})">
                  <!-- <b-icon pack="fas" icon="chart-line" size="is-small" class="mr-2" /> -->
                  {{ $t(btn.text) }}
              </button>

              <button v-if="showBtnKPI" @click="goToKpi"
                class="button is-primary btn-blue mt-2 ml-2 is-size-7">
                {{ $t('kpis') }}
              </button>
          </div>

          

          <!-- PANEL DE FILTROS -->
          <div class="panel">
            <project-notifications-filter
              :project-id="project ? project.id : 0"
              @reload-notifications="reloadNotifications"
            />
          </div>

        </div>
      </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { mapGetters } from 'vuex'
import projectNotifications from '·/components/project-notifications'
import activityTimeStatusCounters from '·/components/activity-time-status-counters'
import projectNotificationsFilter from '·/components/project-notifications-filter'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'
import moment from 'moment'

Vue.use(VueChartkick, {adapter: Chart})

export default {
  middleware: 'auth',
  title: 'project_home_page_title',
  subtitle: 'project_home_page_subtitle',
  menuOption: '2-1',

  components: {
    projectNotifications,
    activityTimeStatusCounters,
    ScaleLoader,
    projectNotificationsFilter,
  },

  data: () => ({
    activitiesList: null,
    okCounter: 0,
    warningCounter: 0,
    dangerCounter: 0,
    usersWorkLoad: null,
    isLoadingTable: true,
    status_assigned: 0,
    status_running: 0,
    status_paused: 0,
    status_issue: 0,
    status_done: 0,
    status_reopened: 0,
    status_closed: 0,

    showPanelRight: true,
    showPanelLeft: true,
    // showPanel: 'both',

    tabSelectedMenu: -1 // tab seleccionado por defecto

  }),

  computed: {
    ...mapGetters({
      user: 'auth/user',
      project: 'app/project',
      company: 'app/company',
      mobile: 'device/mobile',
      visualConfig: 'app/visualConfig', // project configs
    }),

    showPanel: function() {
      if( this.mobile.on_mobile ) {

        if( this.showPanelLeft && this.showPanelRight ) {
          this.tabSelectedMenu = 1
          this.showPanelLeft = false
        }

        return this.showPanelRight ? 'right' : 'left'
      }

      this.showPanelRight = true
      this.showPanelLeft = true
      return 'both'
    },

    isPlanSanea: function() {
      return this.visualConfig?.is_plan_sanea
    },

    showBtnDashboard: function() {
      const btns = typeof this.GetBtnDashboard === "function" ? this.GetBtnDashboard() : [];
      return Array.isArray(btns) && btns.length > 0;
    },

    showBtnKPI() {
      return this.project?.can_admin || this.project?.can_progress;
    },

  },

  watch: {

  },

  mounted() {

  if (this.project == null) {

      this.$router.push('/projects');

    } else {

      // this.getActivitiesList()
      //this.getWorkload()
      let pageInfo = {
        title: this.project.name,
        subtitle: this.$t('project_home_page_subtitle'),
        menuOption: '2-1',
      }

      this.$store.dispatch('app/updatePageInfo', {info: pageInfo})
    }
  },

  methods: {


    reloadNotifications(filters) {
      this.$refs.project_notifications.updateFilters(filters)
    },

    _HandleChangeTab(value) {
      // value contiene el index del tab pulsado siendo
      // 0= el primero tab que corresponde a al menu comments panel comentarios
      // 1= el segundo tab que corresponde al menu dasboard panel derecho

      if (this.mobile.on_mobile) {
        this.showPanelRight = value === 1
        this.showPanelLeft = value === 0
        console.log('change tabvalue: ', value)
      }
      // console.log('change tabSelectedMenu: ', this.tabSelectedMenu)
      // console.log( this.$refs.refTabsMenu.items[this.tabSelectedMenu].label )
    },

    GetBtnDashboard() {
        const btns = this.project && this.project.configs && this.project.configs.dashboards
          ? this.project.configs.dashboards.filter(btn => btn.visible)
          : []
        // Dashboard PRM: entrada al cuadro de mando económico, solo para tkelevator.
        if (this.company && this.company.alias === 'tkelevator') {
          btns.push({ text: 'prm_dashboard_menu', suffix_route: 'prm', visible: true })
        }
        return btns
    },

    goToKpi() {
      this.$router.push({ name: 'project.admin.kpi', params: { project_id: this.project.id } });
    },

  },

};
</script>

<style scoped>
.containt-tabs-menu::v-deep .b-tabs section {
  display: none;
}

.column-scroll {
  /* width: 50%; */
  height: calc(100vh - 150px);
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
